import moment from 'moment-timezone';

/**
 * Plain Date whose calendar Y/M/D match the salon-local day of this moment.
 * Used with pickers that operate on local date components (e.g. CustomDatePicker).
 *
 * @param {import('moment').Moment} m
 * @param {string | null | undefined} timeZone - IANA zone from salon; if missing, uses moment as-is (no tz shift)
 * @returns {Date}
 */
export const momentToSalonCalendarDate = (m, timeZone) => {
  if (!m || !moment.isMoment(m) || !m.isValid()) {
    return new Date();
  }
  const z = timeZone ? m.clone().tz(timeZone) : m.clone();
  return new Date(z.year(), z.month(), z.date());
};

/**
 * Start of that calendar day in the salon zone, from a picker's local Y/M/D.
 *
 * @param {Date} d
 * @param {string | null | undefined} timeZone
 * @returns {import('moment').Moment}
 */
export const salonCalendarDateToMoment = (d, timeZone) => {
  if (!(d instanceof Date) || Number.isNaN(d.getTime())) {
    return moment();
  }
  const y = d.getFullYear();
  const month = d.getMonth();
  const day = d.getDate();
  if (timeZone) {
    return moment.tz({ year: y, month, day, hour: 0, minute: 0, second: 0, millisecond: 0 }, timeZone);
  }
  return moment([y, month, day]).startOf('day');
};
